module.exports = __webpack_public_path__ + "media/images/photography/modal-bg-2dc11c38031ec389e62cd4b80da536af.jpg";